import type { BuildConfig, ClientConfig, CommonConfig, Config, EnvironmentConfig, HostConfig } from './types';

// TODO: sharing tree structure config is a bad idea - refactor to make flat key-value list

let gConfig: Config | null = null;

const lookup = <T>(entries: { readonly [key: string]: T | undefined } | null | undefined, key: string | undefined) =>
  key === undefined ? undefined : entries?.[key];

export const setConfig = (config: Config): void => {
  gConfig = config;
};

export const isMobile = (): boolean => {
  const config = getEnvironmentConfig();
  return config?.client_id?.includes?.('ios') || config?.client_id?.includes?.('android') || false;
};

export const getBuildConfig = (): BuildConfig | undefined => lookup(gConfig?.builds, gConfig?.client?.build_type);
export const getClientConfig = (): ClientConfig | null | undefined => gConfig?.client;
export const getCommonConfig = (): CommonConfig | null | undefined => gConfig?.common;
export const getEnvironmentConfig = (): EnvironmentConfig | undefined =>
  lookup(gConfig?.environments, gConfig?.client?.environment);
export const getHostConfig = (hostOverride?: string): HostConfig | undefined =>
  lookup(gConfig?.hosts, hostOverride || gConfig?.client?.hostname);
export const isDemoMode = (): boolean => Boolean(getHostConfig()?.demo_app);

// For callers that cannot run without the config; they throw when setConfig has not provided it.
const required = <T>(value: T | null | undefined, section: string): T => {
  if (value === null || value === undefined) {
    throw new Error(`${section} config is missing`);
  }
  return value;
};
export const requireBuildConfig = (): BuildConfig => required(getBuildConfig(), 'build');
export const requireClientConfig = (): ClientConfig => required(getClientConfig(), 'client');
export const requireCommonConfig = (): CommonConfig => required(getCommonConfig(), 'common');
export const requireEnvironmentConfig = (): EnvironmentConfig => required(getEnvironmentConfig(), 'environment');
export const requireHostConfig = (hostOverride?: string): HostConfig => required(getHostConfig(hostOverride), 'host');

export const getRedirectUrl = (): string =>
  `${gConfig?.client?.protocol}//${gConfig?.client?.hostname}${
    gConfig?.client?.port ? `:${gConfig?.client?.port}` : ''
  }`;
export const isDevMode = (): boolean =>
  gConfig?.client?.build_type === 'development' || gConfig?.client?.environment !== 'prod';
export const isDevBuild = (): boolean => gConfig?.client?.build_type === 'development';

export { gConfig as default };
